import { ComponentPropsWithoutRef } from "react";
import { Favicon } from "../branding/favicon";
import { cn } from "../../lib/utils";

interface HeaderProps extends ComponentPropsWithoutRef<"header"> {
  title?: string;
  href?: string;
}

function Header({
  title,
  href = "/",
  className,
  children,
}: Readonly<HeaderProps>) {
  return (
    <header
      className={cn(
        "fixed z-50 top-0 left-0 w-full h-12 bg-background/90 backdrop-blur-3xl border-b",
        className,
      )}
    >
      <div className="flex flex-row h-full justify-between items-center gap-12 px-4">
        <figure className="relative z-10 flex flex-row items-center gap-2 p-0 m-0">
          <Favicon size={24} />
          <figcaption>
            <a
              href={href}
              className="flex gap-1 text-base font-semibold text-nowrap truncate"
            >
              <span className="hidden sm:inline font-bold">OREME</span>
              <span className="hidden sm:inline font-light text-border">/</span>
              <span className="font-light">{title}</span>
            </a>
          </figcaption>
        </figure>
        {children}
      </div>
    </header>
  );
}

export { Header };
